export default __webpack_public_path__ + "static/spiritual-india-places-5-14be3f84c6c29aa37aa4448df9eff890.jpg";